import { Copy } from "lucide-react";
import { copyText } from "./util";

const Paste = ({ value, where, testid }) => (
  <div className="flex flex-wrap items-center gap-2">
    {value ? <>
      <code className="font-mono text-xs bg-white border rounded px-2 py-1 break-all" data-testid={testid}>{value}</code>
      <button onClick={() => copyText(value, "Copied " + value)} className="chip !py-1 !px-2.5 !text-xs" data-testid={`${testid}-copy`}><Copy className="w-3 h-3" />Copy</button>
    </> : <span className="text-xs italic text-amber-700" data-testid={testid}>appears here once Altiora's domain server is switched on</span>}
    <span className="text-xs text-slate-500">→ paste into the <b>{where}</b> box</span>
  </div>);

export function RecordSteps({ records, provider }) {
  return (
    <div className="space-y-3" data-testid="domain-record-steps">
      <p className="font-semibold text-[#062a20]">Add each record like this</p>
      {records.map((r, i) => (
        <div key={r.id} className="rounded-xl border border-[#c9a13b]/40 bg-[#fffdf7] p-4 space-y-2.5" data-testid={`domain-record-steps-${i}`}>
          <p className="text-xs uppercase tracking-wide text-[#8a6d1f] font-semibold">Record {i + 1} of {records.length} · {r.why}</p>
          <ol className="space-y-2.5 text-sm list-decimal pl-5">
            <li>On the DNS page at {provider}, click <b>Add record</b> (it may be called Add, Add New Record or +).</li>
            <li>In the <b>Type</b> box, choose <b>{r.type}</b>.</li>
            <li>Copy the name, then paste it into the <b>Name</b> box (it may be called Host or Hostname):<Paste value={r.host} where="Name / Host" testid={`domain-step-${i}-host`} /></li>
            <li>Copy the value, then paste it into the <b>Value</b> box (it may be called Points to, Target, Data or IP address):<Paste value={r.value} where="Value / Points to" testid={`domain-step-${i}-value`} /></li>
            <li>Leave <b>TTL</b> as it is (Automatic or the default).</li>
            <li>Click <b>Save</b>.</li>
          </ol>
          {r.host === "@" && <p className="text-xs text-slate-500">If your provider doesn't accept "@", leave the Name box empty.</p>}
        </div>))}
      <p className="text-xs text-slate-600 bg-slate-50 rounded-lg p-2.5"><b>Don't change anything else.</b> Leave MX, TXT, SPF and DKIM records alone, because they keep your email working. Only edit or remove an old record if we list it in red below.</p>
    </div>);
}
